import React, { FC } from "react";
import { Button, Stack } from "react-bootstrap";
import { Link } from "react-router-dom";
import AppTooltip from "../tooltip";

export interface IRenderAction {
  controlId?: string;
  rowData?: any;
  customButtons?: any;
  wrapperClassName?: any;
}

/**
 * Render Action Functions For Data Grid
 *
 * @param {{ controlId: any; rowData: any; customButtons: any; }} param0
 * @param {*} param0.controlId
 * @param {*} param0.rowData
 * @param {*} param0.customButtons
 * @returns {*}
 */

const RenderAction: FC<IRenderAction> = ({
  controlId,
  rowData,
  customButtons,
  wrapperClassName,
}) => {
  return (
    <Stack direction="horizontal" className={wrapperClassName}>
      {customButtons?.map((buttonItem: any) => {
        return (
          <React.Fragment key={buttonItem?.name}>
            {buttonItem?.enabled && (
              <AppTooltip title={buttonItem?.title} placement="top">
                {buttonItem?.type === "link" ? (
                  <Link
                    className={`custom-width-26 custom-height-26 d-inline-flex align-items-center justify-content-center p-0 lh-1 theme-${buttonItem?.class}-btn link-dark ${buttonItem?.disabled ? "pe-none opacity-50" : ""}`}
                    to={
                      buttonItem?.customLink ??
                      `/${controlId}/${buttonItem?.name}/${rowData?.id}`
                    }
                    aria-label={buttonItem?.title}
                    target={buttonItem?.target || "_self"}
                  >
                    {buttonItem?.icon}
                  </Link>
                ) : (
                  <Button
                    className={`custom-width-26 custom-height-26 d-inline-flex align-items-center justify-content-center p-0 lh-1 theme-${buttonItem.class}-btn link-dark`}
                    variant="link"
                    disabled={buttonItem?.disabled}
                    onClick={buttonItem?.handler}
                    aria-label={buttonItem?.title}
                  >
                    {buttonItem.icon}
                  </Button>
                )}
              </AppTooltip>
            )}
          </React.Fragment>
        );
      })}
    </Stack>
  );
};

export default RenderAction;
